'use client'
import { useState } from 'react'
import { TitleDivider } from 'components/TitleDivider'
import { useMemoizedContentGetter } from 'utils/contentful'
import styles from './AboutUsLeadership.module.scss'
import { Grid, Collapse, Button } from '@achieve/ascend'
import Section from 'components/Section'
import { useViewportSmallerThan } from 'utils/viewport'
import { BREAKPOINTS } from 'constants/viewport'
import { CardLeadership } from 'components/Cards'
import { ChevronUp, ChevronDown } from 'react-feather'
import { AboutUsLeadershipBody } from './AboutUsLeadershipBody'

function AboutUsLeadership({ content }) {
  const [expanded, setExpanded] = useState(false)
  const memoizedContent = useMemoizedContentGetter(content, [
    'aboutUsLeadershipTitle',
    'aboutUsLeadershipSubtitle',
    'aboutUsLeadershipGrid',
    'config',
    'aboutUsLeadership',
  ])
  const isMobile = useViewportSmallerThan(BREAKPOINTS.xl)

  const { aboutUsLeadershipGrid, aboutUsLeadershipTitle, config, aboutUsLeadership } =
    memoizedContent
  const xl = config?.jsonContent?.xl || 3
  const collapseHandler = () => {
    setExpanded((wasExpanded) => !wasExpanded)
  }

  const collapsibleItems = [...aboutUsLeadershipGrid.gridItemsCollection.items]
  const nonCollapsibleItems = isMobile ? collapsibleItems.splice(0, 4) : collapsibleItems

  return (
    <Section
      className={styles['about-us-leadership-section']}
      data-testid="about-us-leadership-section"
    >
      <TitleDivider
        data-testid="leadership-title-divider"
        title={aboutUsLeadershipTitle}
        className={styles['title']}
        classNameTitleText="displayMd lg:displayLg"
        classNameSubtitleText="bodySm lg:displaySm font-light!"
      />
      <div data-testid="leadership-content" className={styles['content-container']}>
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          rowSpacing={3}
          columnSpacing={4}
        >
          {nonCollapsibleItems.map((content, i) => {
            return (
              <Grid
                size={{ xs: 12, md: 6, xl: xl }}
                className={styles.item}
                key={i}
                data-testid={`leadership-content-grid-item-${i}`}
              >
                <CardLeadership content={content} testIdIndex={i} />
              </Grid>
            )
          })}
        </Grid>
        {isMobile && (
          <>
            <Collapse in={expanded}>
              <Grid
                container
                direction="row"
                justifyContent="center"
                alignItems="center"
                rowSpacing={3}
                columnSpacing={4}
                className={styles.collapsible}
              >
                {collapsibleItems.map((content, i) => {
                  return (
                    <Grid
                      size={{ xs: 12, md: 6, xl: 3 }}
                      className={styles.item}
                      key={i}
                      data-testid={`leadership-content-grid-item-${i + 4}`}
                    >
                      <CardLeadership content={content} testIdIndex={i + 4} />
                    </Grid>
                  )
                })}
              </Grid>
            </Collapse>
            <Button
              endIcon={expanded ? <ChevronUp /> : <ChevronDown />}
              className={styles['collapse-button']}
              onClick={collapseHandler}
              variant="text"
              data-testid="leadership-expand-button"
            >
              {expanded ? 'Show less' : 'Show more'}
            </Button>
          </>
        )}
        <AboutUsLeadershipBody content={aboutUsLeadership} />
      </div>
    </Section>
  )
}
export { AboutUsLeadership }
export default AboutUsLeadership
